import { firebase } from './firebaseConfig';
import {compressAccurately} from 'image-conversion';
const db = firebase.firestore();

// =============== CREATE AUTHOR =======================
export async function createAuthor() {
  const user = firebase.auth().currentUser;
  if (user) {
    const { displayName, uid } = user;
    const existingRecord = await db.collection('users').doc(uid).get();

    if (!existingRecord.exists) {
      db.collection('users').doc(uid).set({
        authorName: displayName,
        upvotesReceived: 0,
        numberComments: 0, 
        numberPoints: 0,
        authorProfile: `/users/${uid}`,
        numberPosts: 0,
        dateJoined: new Date()
      })
      .then(() => firebase.analytics().logEvent('signup'))
      .catch((error) => console.error(error.code, error.message));
    }
  }
}

// ============ GET NUM POINTS ================
export async function getPoints(authorID, setState) {
  const numberPoints = await db.collection('users').doc(authorID).get();
  if (numberPoints.exists) setState(numberPoints.data().numberPoints);
  else setState(0);
}

// ========== EDIT PROFILE PICTURE =============
export async function editProfilePicture({authorID, file, setResult}) {
  compressAccurately(file, {
    size: 15,
    type: "image/jpeg",
    width: 300
  }).then((res) => {
    const storageRef = firebase.storage().ref();
    const pathRef = storageRef.child(`profilePictures/${authorID}/profile.jpg`);
    pathRef.put(res).then(() => setResult('success'))
    .catch(() => setResult('error'));
  })
  .catch(() => setResult('error'));
}

// ========== EDIT PROFILE INFO ===============
export async function editProfileInfo({bio, website, authorID, location, setResult}) {
  const updates = {};
  if (bio) updates.bio = bio;
  if (website) {
    updates.contacts = {}; updates.contacts.website = website;
  }
  if (location) updates.location = location;
  db.collection('users').doc(authorID).collection('private').doc('data').update(updates)
  .then(() => setResult('success'))
  .catch(() => setResult('error'));
}